import { useQuery } from '@tanstack/react-query'

import { useBackendClient } from '../contexts/BackendClientContext'
import { PositionsGetGlobalMetricsResponseType } from '../../backend/types'

const CACHE_KEY = 'position-global-metrics'

export const usePositionsGlobalMetrics = () => {
  const backendClient = useBackendClient()

  const results = useQuery({
    queryKey: [CACHE_KEY],
    queryFn: async () => {
      const positionsGlobalMetrics =
        (await backendClient.positionsGetGlobalMetrics()) as PositionsGetGlobalMetricsResponseType

      return positionsGlobalMetrics
    },
    refetchInterval: 1000 * 30,
    staleTime: 1000 * 30,
  })

  return {
    isLoading: results.isLoading,
    data: results.data,
  }
}
